module.exports = __webpack_public_path__ + "img/3.d1865300.png";